import { lazy } from 'react'

export const AssetList = lazy(() => import('./asset/AssetList'))
export const AssetServiceList = lazy(() => import('./assetService/AssetServiceList'))
export const AssetInwardList = lazy(() => import('./assetInward/AssetInwardList'))
export const ScheduleList = lazy(() => import('./schedule/ScheduleList'))
export const JobCardList = lazy(() => import('./jobCard/JobCardList'))
export const WorkOrderList = lazy(() => import('./workOrder/WorkOrderList'))
export const AdminMaintenance = lazy(() => import('./admin-maintenance/AdminMaintenance'))